import { Outlet } from 'react-router-dom'

import { ErrorProvider } from '@/contexts/ErrorContext'

const AuthLayout = () => {
  return (
    <ErrorProvider>
      <div>
        <Outlet />
      </div>
    </ErrorProvider>
  )
}

export default AuthLayout
